import { useNavigate } from 'react-router-dom';
import { WizardProvider, useWizard } from './WizardProvider';
import Step1Account from './steps/Step1Account';
import Step2LosIntegrations from './steps/Step2LosIntegrations';
import Step3Products from './steps/Step3Products';
import Step4Users from './steps/Step4Users';
import Step5Review from './steps/Step5Review';

function WizardSteps() {
  const { state } = useWizard();
  const navigate = useNavigate();
  const exit = () => navigate('/lenders');

  switch (state.step) {
    case 1:
    default:
      return <Step1Account onExit={exit} />;
    case 2:
      return <Step2LosIntegrations onExit={exit} />;
    case 3:
      return <Step3Products onExit={exit} />;
    case 4:
      return <Step4Users onExit={exit} />;
    case 5:
      return <Step5Review onExit={exit} />;
  }
}

export default function LenderWizardPage() {
  return (
    <WizardProvider>
      <WizardSteps />
    </WizardProvider>
  );
}
